import { useState, useRef, useEffect } from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import Length from "./Length";
import Clock from "./Clock";
import Controls from "./Controls";
import SpaceGrotesk from "../fonts/Space_Grotesk/SpaceGrotesk-Regular.ttf";

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: SpaceGrotesk;
    src: url(${SpaceGrotesk});
  }

  html, body {
    margin:0;
    padding:0;
  }

  html {
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

const OuterBox = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient( 109.7deg,  rgba(229,0,57,1) 1.8%, rgba(162,91,182,1) 90.2% );
  background-color: #FF3CAC;
  background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);
`;

const InnerBox = styled.div`
  width: 450px;
  min-height: 600px;
  text-align: center;
  display: flex;
  border: 1.5px solid white;
  box-shadow: rgba(255, 255, 255, 0.3) 0px 7px 25px 0px;
  border-radius: 12.5px;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.font};
`;

const Heading = styled.h1`
  font-size: 2.5em;
  text-shadow: rgba(255, 255, 255, 0.3) 0px 7px 25px;
  margin:0;
`;

const LengthDiv = styled.div`
  display: flex;
  & > * {
    flex: 1;
  }
`;

const theme = {
  color: "#fff",
  font: "SpaceGrotesk"
};

const App = () => {

  const [session, setSession] = useState(1500);
  const [recess, setRecess] = useState(300);
  const [seconds, setSeconds] = useState(0);

  const [timerRunning, setTimerRunning] = useState(false);
  const [clockStatus, setClockStatus] = useState("Session");

  const intervalRef = useRef(null);
  const audioRef = useRef(null);

  // refs for referencing the latest value in setInterval
  const secondsRef = useRef(seconds);
  secondsRef.current = seconds;
  const clockStatusRef = useRef(clockStatus);
  clockStatusRef.current = clockStatus;

  useEffect(() => {
    if (clockStatus === "Recess")  setSeconds(recess);
  }, [clockStatus, recess]);

  useEffect(() => {
    if (clockStatus === "Session")  setSeconds(session);
  }, [clockStatus, session]);

  const startTimer = () => {
    // clearing any existing intervals
    clearInterval(intervalRef.current);
    setTimerRunning(true);

    intervalRef.current = setInterval(() => {

      if(secondsRef.current <= 0){
        if(clockStatusRef.current === "Session"){
          setClockStatus("Recess");
        }
        else if(clockStatusRef.current === "Recess") {
          setClockStatus("Session");
        }
        return;
      }

      setSeconds(current => current - 1);

      if(secondsRef.current === 0){
        audioRef.current.play();
      }
    }, 1000);
  };

  const stopTimer = () => {
    setTimerRunning(false);
    clearInterval(intervalRef.current);
  };

  const controlTimer = () => {
    timerRunning ? stopTimer() : startTimer();
  }

  const resetTimer = () => {
    clearInterval(intervalRef.current);
    setTimerRunning(false);
    setSession(1500);
    setRecess(300);
    setClockStatus("Session");
    setSeconds(session); // fallback
    intervalRef.current = null;
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  };

  return (
    <>
      <GlobalStyle />
      <OuterBox>
        <ThemeProvider theme={theme}>
          <InnerBox>
            <Heading>25 + 5 Clock</Heading>
            <LengthDiv>
              <Length timerRunning={timerRunning} length={recess} setLength={setRecess} content={"Recess"} />
              <Length timerRunning={timerRunning} length={session} setLength={setSession} content={"Session"} />
            </LengthDiv>
            <Clock seconds={seconds} clockStatus={clockStatus} />
            <audio ref={audioRef} src="https://raw.githubusercontent.com/freeCodeCamp/cdn/master/build/testable-projects-fcc/audio/BeepSound.wav"></audio>
            <Controls controlTimer={controlTimer} resetTimer={resetTimer} />
          </InnerBox>
        </ThemeProvider>
      </OuterBox>
    </>
  );
};

export default App;